import { useEffect } from 'react';

/** Calls onHit when `ref`'s element scrolls into view, while `enabled`. */
export function useInfiniteScroll(
  ref: React.RefObject<HTMLElement>,
  onHit: () => void,
  enabled: boolean,
): void {
  useEffect(() => {
    const el = ref.current;
    if (!el || !enabled) return;
    const obs = new IntersectionObserver((entries) => {
      if (entries.some((e) => e.isIntersecting)) onHit();
    }, { rootMargin: '400px' });
    obs.observe(el);
    return () => obs.disconnect();
  }, [ref, onHit, enabled]);
}
